import { useState } from "react";
import { analyticsPushFunc, openFacebookShare, openTwitterShare } from "../../../widgetsUtils";
import { WhatsAppShareButton } from "../../../siteWidgets/socialShareButtons/whatsApp/whatsAppShareButton";
import { FrontCopyButton } from "../../../commonComponents/inline/frontCopyButton/frontCopyButton";

interface VerticalShareAreaProps {
    title: string;
    domain: string;
    isMobile: boolean;
    videoPageId: string;
    copyLinkLabel: string;
    linkCopiedLabel: string;
    shareItemType: ShareItemType
    link?: string;
    articleId?: string;
    analyticShareLabel?: string;
}

export type ShareItemType = "verticalVideo" | "newsFlash" | "rylz";

export const VerticalShareArea = (props: VerticalShareAreaProps) => {

    const { domain, isMobile, videoPageId, title, copyLinkLabel, linkCopiedLabel, link, analyticShareLabel, shareItemType, articleId } = props;
    const [isVisible, setIsVisible] = useState(false);

    const linkToShare = link || `${domain}/video/${videoPageId}`;
    const analyticLabel = analyticShareLabel || "vertical_video";
    const analyticItemTitle = getAnalyticItemTitle(shareItemType);
    const itemId = shareItemType === "verticalVideo" ? videoPageId : articleId;

    // const baseUrl = `${domain}/video/${videoPageId}`;
    // const shareUrl = `${baseUrl}?utm_source=ynet.co.il&utm_medium=share&utm_campaign=copy_url&utm_content=vertical_video`;

    const onToggle = async () => {
        if (isMobile) {
            try {
                // @ts-ignore
                await navigator.share({ url: linkToShare });
            } catch (err) {
                console.log("error with sharing function", err);
            }
        } else {
            setIsVisible(!isVisible);
        }
    };

    const onShareBtnClicked = (button: string) => {
        setIsVisible(false);

        if (typeof window !== "undefined") {
            switch (button) {
                case "fb":
                    openFacebookShare(linkToShare, "", () => analyticsPushFunc("Facebook", analyticItemTitle, analyticLabel), title, itemId);
                    break;
                case "tw":
                    openTwitterShare(linkToShare, () => analyticsPushFunc("Twitter", analyticItemTitle, analyticLabel), title, itemId);
                    break;
                case "wa":
                    WhatsAppShareButton.openWhatsAppShare(linkToShare, () => analyticsPushFunc("WhatsApp", analyticItemTitle, analyticLabel), title, itemId);
                    break;
            }
        }
    };

    if (!itemId) return null;

    return (
        <div className="shareArea">
            <div className="shareBtn" onClick={onToggle}></div>

            {isVisible &&
                <div className="mediaShareWrapper">
                    <div className="mediaShareItem" onClick={() => onShareBtnClicked("fb")}>
                        <div className="mediaShareIcon facebook"></div>
                        <div className="mediaShareText">Facebook</div>
                    </div>

                    <div className="mediaShareItem" onClick={() => onShareBtnClicked("wa")}>
                        <div className="mediaShareIcon whatsapp"></div>
                        <div className="mediaShareText">WhatsApp</div>
                    </div>

                    <div className="mediaShareItem" onClick={() => onShareBtnClicked("tw")}>
                        <div className="mediaShareIcon twitter"></div>
                        <div className="mediaShareText">Twitter</div>
                    </div>

                    <div className="mediaShareItem">
                        <FrontCopyButton popupText={linkCopiedLabel} title={title} url={linkToShare} />

                        <div className="mediaShareText">{copyLinkLabel}</div>
                    </div>
                </div>
            }
        </div>
    );
};

const getAnalyticItemTitle = (shareItemType: ShareItemType) => {
    switch (shareItemType) {
        case "verticalVideo":
            return "Vertical Video";
        case "newsFlash":
            return "News Flash";
        case "rylz":
            return "Rylz Article";
        default:
            return "";
    }
};
